const getIsViewer = ({permission} = {}) => (typeof permission === 'object' ? permission.permission : permission) === 'viewer';

export default getIsViewer;
